import React from 'react';
import { motion } from 'framer-motion';
import { MessageSquare } from 'lucide-react';
import { Button } from './ui/button';
export function FinalCTA() {
  return <section id="contact" className="relative min-h-[70vh] flex items-center overflow-hidden bg-navy" data-id="element-12">
      {/* Parallax Background with Green Glow */}
      <div className="absolute inset-0 bg-gradient-to-br from-navy via-navy to-[#0a0f1a]" data-id="element-13">
        {/* Animated green glow effects */}
        <motion.div animate={{
        scale: [1, 1.2, 1],
        opacity: [0.3, 0.5, 0.3]
      }} transition={{
        duration: 4,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-lime/20 rounded-full blur-3xl" data-id="element-14" />
        <motion.div animate={{
        scale: [1.2, 1, 1.2],
        opacity: [0.2, 0.4, 0.2]
      }} transition={{
        duration: 5,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="absolute top-1/3 right-1/4 w-96 h-96 bg-electric-blue/20 rounded-full blur-3xl" data-id="element-15" />
      </div>

      <div className="container mx-auto px-4 py-20 relative z-10" data-id="element-16">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center space-y-8 max-w-4xl mx-auto" data-id="element-17">
          {/* Logo */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative inline-block" data-id="element-18">
            <div className="absolute inset-0 bg-lime/30 rounded-full blur-3xl scale-150" data-id="element-19" />
            <img src="https://cdn.magicpatterns.com/uploads/tAQ2hBAg2YykrLwSQc6Y3H/AZ-JunkNerds-logo-v2.png" alt="AZ Junk Nerds" className="relative w-48 md:w-64 mx-auto drop-shadow-[0_0_40px_rgba(163,230,53,0.5)]" data-id="element-20" />
          </motion.div>

          {/* Headline */}
          <h2 className="font-heading text-5xl md:text-6xl lg:text-7xl text-white tracking-wider leading-tight" data-id="element-21">
            READY TO MAKE YOUR{' '}
            <span className="text-lime text-shadow-neon" data-id="element-22">JUNK DISAPPEAR?</span>
          </h2>

          {/* Subheadline */}
          <p className="text-xl md:text-2xl text-white/80 font-medium" data-id="element-23">
            Free quotes. Same-day service. Zero hassle.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4" data-id="element-24">
            <Button size="lg" className="bg-lime text-navy hover:bg-lime/90 font-bold text-lg px-10 h-16 rounded-full shadow-[0_0_25px_rgba(163,230,53,0.6)] hover:shadow-[0_0_40px_rgba(163,230,53,0.8)] transition-all" data-id="element-25">
              GET FREE QUOTE NOW
            </Button>
            <a href="tel:4252697387" className="inline-flex" data-id="element-26">
              <Button size="lg" variant="outline" className="border-2 border-lime text-lime hover:bg-lime/10 font-bold text-lg px-10 h-16 rounded-full w-full" data-id="element-27">
                <MessageSquare className="w-5 h-5 mr-2" data-id="element-28" />
                TEXT A PHOTO: (425) 269-7387
              </Button>
            </a>
          </div>

          {/* Small Text */}
          <p className="text-white/60 text-sm pt-4" data-id="element-29">
            Licensed. Insured. Family-owned in Phoenix, AZ.
          </p>
        </motion.div>
      </div>
    </section>;
}